<div class="authentication">
  <div class="welcome-text">
    <p class="text-center text-white">
      <small
        >Welcome to Metrium Please log in to your account to access the full
        range of features and functionalities offered by our platform. If you
        don't have an account yet, you can easily sign up for one to get
        started.</small
      >
    </p>
  </div>
  <div class="auth-wrap-inner container">
    <router-outlet></router-outlet>
  </div>
  <div class="auth-footer">
    <ul>
      <li>
        <a
          href="javascript:;"
          data-bs-toggle="modal"
          data-bs-target="#termsModal"
          >Terms of Service</a
        >
      </li>
      <li>
        <a
          href="javascript:;"
          data-bs-toggle="modal"
          data-bs-target="#privacyModal"
          >Privacy Policy</a
        >
      </li>
      <!-- <li><a href="javascript:;">About Us</a></li> -->
    </ul>
  </div>
</div>
<!-- Terms of Service Modal -->
<div
  class="modal fade"
  id="termsModal"
  tabindex="-1"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
>
  <div
    class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg"
  >
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Terms of Service</h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <p><strong>Last Update Date:</strong> 01 Dec 2024</p>
        <p>
          This website (the "Site") is owned and operated by Metrium Dynamics
          Private Limited (“Metrium”, "we," "our," or "us"). By using the Site,
          you agree to comply with these Terms. If you do not agree with any of
          these Terms, please refrain from using the Site.
        </p>
        <ol class="ps-3">
          <li>
            <h6>Acceptance of Terms</h6>
            <p>
              By accessing or using the Metrium Site, you agree to abide by
              these Terms and any applicable laws and regulations. We reserve
              the right to modify or update these Terms at any time. All updates
              will be posted on this page, and the date of the latest revision
              will be updated accordingly. Continued use of the Site after such
              changes constitutes your acceptance of the new Terms.
            </p>
          </li>
          <li>
            <h6>Account Registration</h6>
            <p>
              To access certain features of the Site, you may need to create an
              account. You agree to provide accurate, complete, and up-to-date
              information during registration and maintain the accuracy of such
              information. You are responsible for safeguarding your account
              credentials and are fully responsible for all activities that
              occur under your account.
            </p>
          </li>
          <li>
            <h6>Limited License</h6>
            <p>
              Subject to the terms and conditions outlined in this notice,
              Metrium grants you a non-exclusive, non-transferable, limited
              right to access, use, and display this Site and its materials for
              personal or project-related, non-commercial purposes, unless
              explicitly authorized by Metrium.
            </p>
            <p class="mb-2">You agree not to:</p>
            <ul class="mb-3">
              <li>
                Interrupt or attempt to disrupt the operation of the Site.
              </li>
              <li>Alter or attempt to alter the content of the Site.</li>
              <li>Deface or interfere with the Site in any way.</li>
            </ul>
            <p>
              This authorization is not a transfer of ownership in the materials
              and is subject to the following restrictions:
            </p>
            <ul class="mb-3">
              <li>
                Retain all copyright and proprietary notices on all copies of
                the materials.
              </li>
              <li>
                Do not modify, reproduce, publicly display, perform, distribute,
                or use the materials for commercial or public purposes.
              </li>
              <li>
                Do not transfer the materials to others without ensuring they
                acknowledge and accept the obligations of these terms.
              </li>
            </ul>
            <p>
              You are also required to comply with any additional restrictions
              displayed on the Site. The Site and all its materials are
              protected by copyright laws. You agree to respect these laws and
              prevent unauthorized copying of the materials.
            </p>
          </li>
          <li>
            <h6>General Disclaimer</h6>
            <p>
              Information on this Site is provided "as is" without warranty of
              any kind, either express or implied, including, but not limited
              to, the implied warranties of merchantability, fitness for a
              particular purpose, or non-infringement. Metrium does not warrant
              that the Site or any linked sites will be error-free or that they
              will meet your expectations.
            </p>
            <p>
              In no event will Metrium be liable for any direct, indirect,
              special, or consequential damages resulting from the use of this
              Site, even if we have been advised of the possibility of such
              damages.
            </p>
            <p>
              Metrium makes no warranty or representation regarding any external
              websites linked to the Site and is not responsible for any content
              or services provided through them.
            </p>
          </li>
          <li>
            <h6>Copyright</h6>
            <p>
              All content, materials, and programs on this Site, including text,
              graphics, logos, and software, are the exclusive property of
              Metrium unless stated otherwise. The overall look and feel of the
              Site are also the exclusive property of Metrium.
            </p>
          </li>
          <li>
            <h6>Trademarks</h6>
            <p>
              The trademarks, service marks, and logos displayed on this Site
              are registered and unregistered trademarks of Metrium and its
              affiliates. No part of this Site should be construed as granting
              you any license or right to use any trademarks displayed on the
              Site without prior written permission from Metrium.
            </p>
            <p>
              Metrium aggressively enforces its intellectual property rights.
              The use of the Metrium logo or any related marks in advertising or
              publicity requires prior written approval.
            </p>
          </li>
          <li>
            <h6>Data Collection and Privacy</h6>
            <p>
              By using the Site, you consent to the collection, storage, and use
              of your personal and project-related data in accordance with our
              <strong>Privacy Policy</strong>. We may collect data related to
              your usage of the Site, which helps us improve our services. For
              more details on how we handle your information, please refer to
              our Privacy Policy.
            </p>
          </li>
          <li>
            <h6>International Users and Choice of Law</h6>
            <p>
              This Site is controlled, operated, and administered by Metrium
              from its offices in India. Access to this Site from locations
              where its content is illegal is prohibited. If you access this
              Site from outside India, you are responsible for compliance with
              all local laws.
            </p>
            <p>
              The laws of India shall govern these Terms and Conditions, without
              regard to its conflict of law provisions.
            </p>
          </li>
          <li>
            <h6>Third-Party Links and Integrations</h6>
            <p>
              Metrium may provide links to third-party websites as a
              convenience. However, Metrium does not endorse or guarantee the
              content of these external sites. You access these sites at your
              own risk and are responsible for taking precautions to protect
              yourself from viruses or other harmful content.
            </p>
            <p>
              Metrium does not sponsor or affiliate itself with any third-party
              sites that may be linked, nor does it grant authorization to use
              its trademarks or logos unless explicitly agreed.
            </p>
          </li>
          <li>
            <h6>Limitations of Liability</h6>
            <p>
              To the fullest extent permitted by law,
              <strong>Metrium</strong> shall not be liable for any indirect,
              incidental, special, consequential, or punitive damages arising
              from or in connection with your use of the Site, including but not
              limited to loss of data, business interruption, or loss of
              revenue.
            </p>
          </li>
          <li>
            <h6>Termination</h6>
            <p>
              We reserve the right to suspend or terminate your access to the
              Site at any time, with or without notice, for conduct that
              violates these Terms or for any other reason. Upon termination,
              you must immediately cease all use of the Site.
            </p>
          </li>
          <li>
            <h6>Governing Law</h6>
            <p>
              These Terms will be governed by and construed in accordance with
              the laws of <strong>India</strong>, without regard to its conflict
              of law principles. Any disputes arising under these Terms shall be
              subject to the exclusive jurisdiction of the courts across India.
            </p>
          </li>
          <li>
            <h6>Contact Information</h6>
            <p>
              For any questions or concerns regarding these Terms, please
              contact us at: <strong>Email: </strong>
              <a href="mailto:support@metrium.in">support&#64;metrium.in</a>
            </p>
            <p>
              By using the Site, you acknowledge that you have read, understood,
              and agree to be bound by these Terms and Services.
            </p>
          </li>
        </ol>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
          Close
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Ends Terms of Service Modal  -->

<!-- privacyPolicy Modal -->
<div
  class="modal fade"
  id="privacyModal"
  tabindex="-1"
  aria-labelledby="privacyPolicyLabel"
  aria-hidden="true"
>
  <div
    class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg"
  >
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Privacy Policy</h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <p><strong>Effective Date:</strong> 01 Dec 2024</p>
        <p>
          Metrium Dynamics Private Limited (“Metrium,” “we,” or “us”) values
          your privacy and is dedicated to protecting it. This policy outlines
          how we collect, use, and safeguard your information when you engage
          with our services.
        </p>
        <h5 class="mb-3">Part I – Information We Collect and Manage</h5>
        <ol class="ps-3 mb-3">
          <li>
            <h6>Information We Actively Collect</h6>
            <ul class="mb-3">
              <li>
                When you create an account, request support, or purchase
                services, we may collect details such as your name, email
                address, designation and project.
              </li>
              <li>
                If you communicate with us through feedback forms, surveys, or
                customer support channels, we may collect additional information
                related to your queries, preferences, or suggestions to enhance
                our services.
              </li>
            </ul>
          </li>
          <li>
            <h6>Information Collected Automatically</h6>
            <ul class="mb-3">
              <li>
                When you access our Site, we log data such as device type,
                browser settings, and navigation patterns.
              </li>
              <li>
                This data helps us enhance user experience, optimize features,
                and support future product development.
              </li>
            </ul>
          </li>
          <li>
            <h6>Information from Third Parties</h6>
            <ul class="mb-3">
              <li>
                If you interact with our Site through Google search or
                project-based links, we may receive your contact details.
              </li>
              <li>
                This information is used solely to fulfill your requests and
                improve our services
              </li>
            </ul>
          </li>
        </ol>
        <h5 class="mb-3">Part II - How We Use Your Information</h5>
        <p class="mb-2">We use your information to:</p>
        <ul>
          <li>
            Deliver and maintain services, monitor account security, and
            communicate updates.
          </li>
          <li>
            Enhance product features and gather feedback for improvements.
          </li>
          <li>
            Inform you about relevant products, features, or policy changes.
          </li>
        </ul>
        <h6>Legal Basis for Processing</h6>
        <p class="mb-2">
          We are compliant with the Digital Personal Data Protection Act (DPDPA)
          and Information Act. We process your information based on:
        </p>
        <ul>
          <li>Your consent or a service agreement.</li>
          <li>
            Legitimate business interests, such as improving services and
            ensuring compliance with regulations.
          </li>
        </ul>
        <p>
          You may opt out of non-essential data collection, such as disabling
          cookies in your browser settings. However, some functionalities may be
          affected.
        </p>
        <h5 class="mb-3">Part III - Data Sharing and Security</h5>
        <ul>
          <li>
            We limit access to personal information to admins with a legitimate
            need.
          </li>
          <li>We do not share your data with any third parties.</li>
        </ul>
        <h6>Data Storage</h6>
        <ul>
          <li>
            Your data is securely stored on servers located in India, ensuring
            full compliance with applicable data protection regulations for this
            region.
          </li>
        </ul>
        <h5 class="mb-3">Part IV - Your Rights</h5>
        <ul>
          <li>
            Access, update, or request the deletion of your personal data.
          </li>
          <li>Decline certain processing or request data portability.</li>
          <li>
            In accordance with the Digital Personal Data Protection Act (DPDPA),
            as per India’s standards, you have the right to access, correct, or
            request deletion of your personal data.
          </li>
        </ul>
        <p>
          We retain your data as long as necessary for stated purposes. Once no
          longer needed, your data will be anonymized or deleted.
        </p>
        <h5 class="mb-3">Part V - Information Processed on Your Behalf</h5>
        <p>
          When you use our services to manage end users or third party data, you
          entrust this information to us, referred to as
          <strong>Service Data</strong>.
        </p>
        <h6>Ownership and Handling of Service Data</h6>
        <ul>
          <li>
            You own all Service Data. We only process it as per your
            instructions and secure it with strict measures.
          </li>
          <li>
            You can request access, export, or deletion of Service Data at any
            time.
          </li>
        </ul>
        <h6>Data Retention and Deletion</h6>
        <ul>
          <li>
            We retain Service Data as long as your account remains active.
          </li>
          <li>
            Upon account termination, active database data will be deleted
            within 6 months, and backups within 3 months thereafter.
          </li>
        </ul>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
          Close
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Ends privacyPolicy Modal  -->
